import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core'
import { IGroupRule, IGroupRuleChangeEvent } from '../group-rule.model'
import { IRule, IRuleChangeEvent } from '../rule.model'
import { ConditionsEnum } from '../definitions.enum'

@Component({
    selector: 'app-group-of-rules',
    templateUrl: './group-of-rules.component.html',
    styleUrls: ['./group-of-rules.component.scss'],
    standalone: false
})
export class GroupOfRulesComponent implements OnInit {
  @Input() groupRuleInput: IGroupRule
  @Input() level: number = 1
  @Input() deepLevel: number = 5
  @Input() index: number = 0
  @Input() allowCollapse: boolean = true
  @Input() disableRemove: boolean = false
  @Output() removeGroupEvent: EventEmitter<number> = new EventEmitter<number>()
  @Output() removeRuleEvent: EventEmitter<number> = new EventEmitter<number>()
  @Output() groupChangeEvent: EventEmitter<IGroupRuleChangeEvent> = new EventEmitter<
    IGroupRuleChangeEvent
  >()

  public isCollapsed = false

  private _condition: ConditionsEnum.AND | ConditionsEnum.OR = ConditionsEnum.AND
  private _items: { type: 'RULE' | 'GROUP' }[] = []
  private _groupRule: IGroupRule = { condition: this._condition, rules: [] }

  public get condition(): ConditionsEnum.AND | ConditionsEnum.OR {
    return this._condition
  }

  public get items(): { type: 'RULE' | 'GROUP' }[] {
    return this._items
  }

  constructor() {}

  public addRule(): void {
    this._items.push({ type: 'RULE' })
    this._groupRule.rules.push({ field: null, operator: null, value: null })
    this.groupChangeEvent.next({ index: this.index, group: this._groupRule })
  }

  public addGroup(): void {
    this._items.push({ type: 'GROUP' })
    this._groupRule.rules.push({ condition: ConditionsEnum.AND, rules: [] })
    this.groupChangeEvent.next({ index: this.index, group: this._groupRule })
  }

  public onRemoveGroup($event): void {
    this.removeGroupEvent.next($event)
  }

  public onRemoveChildItem(index: number): void {
    this._items.splice(index, 1)
    this._groupRule.rules.splice(index, 1)
    this.groupChangeEvent.next({ index: this.index, group: this._groupRule })
  }

  public onRuleValueChanged(event: IRuleChangeEvent): void {
    this._groupRule.rules[event.index] = event.rule
    this.groupChangeEvent.next({ index: this.index, group: this._groupRule })
  }

  public onGroupValueChanged(event: IGroupRuleChangeEvent): void {
    this._groupRule.rules[event.index] = event.group
    this.groupChangeEvent.next({ index: this.index, group: this._groupRule })
  }

  public setCondition(condition: ConditionsEnum.AND | ConditionsEnum.OR): void {
    this._condition = condition
    this._groupRule.condition = this._condition
    this.groupChangeEvent.next({ index: this.index, group: this._groupRule })
  }

  public getAndCondition(): ConditionsEnum.AND {
    return ConditionsEnum.AND
  }

  public getOrCondition(): ConditionsEnum.OR {
    return ConditionsEnum.OR
  }

  private parseGroupRuleInput(): void {
    if (this.groupRuleInput) {
      this._condition = this.groupRuleInput.condition
      if (this.groupRuleInput.rules.length > 0) {
        for (let i = 0; i < this.groupRuleInput.rules.length; i++) {
          const ruleOrGroup = this.groupRuleInput.rules[i]
          if (ruleOrGroup['rules'] === undefined) {
            this._items.push({ type: 'RULE' })
            this._groupRule.rules.push(ruleOrGroup)
          } else {
            this._items.push({ type: 'GROUP' })
            this._groupRule.rules.push(ruleOrGroup)
          }
        }
      }
    }
  }

  public getRuleFromInput(index: number): undefined | IRule {
    if (this.groupRuleInput) {
      const rule = this.groupRuleInput.rules[index]
      if (rule && rule['rules'] === undefined) {
        return rule as IRule
      }
    }
    return undefined
  }

  public getGroupRuleFromInput(index: number): undefined | IGroupRule {
    if (this.groupRuleInput) {
      const group = this.groupRuleInput.rules[index]
      if (group && group['rules'] !== undefined) {
        return group as IGroupRule
      }
    }
    return undefined
  }

  ngOnInit(): void {
    this.parseGroupRuleInput()
  }
}
